<template>
  <div class="tbs-header">
    <div class="tb-inr-1">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link active"
            id="profile-tab"
            data-bs-toggle="tab"
            data-bs-target="#profile"
            type="button"
            role="tab"
            aria-controls="profile"
            aria-selected="true"
            @click="$emit('tab-change', 'profile')"
          >
            Profile
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="summary-tab"
            data-bs-toggle="tab"
            data-bs-target="#summary"
            type="button"
            role="tab"
            aria-controls="summary"
            aria-selected="true"
            @click="$emit('tab-change', 'summary')"
          >
            Summary
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="timeslot-tab"
            data-bs-toggle="tab"
            data-bs-target="#timeslot"
            type="button"
            role="tab"
            aria-controls="timeslot"
            aria-selected="false"
            @click="$emit('tab-change', 'timeslot')"
          >
            Time Slots
          </button>
        </li>
      </ul>
    </div>
    <div class="tb-inr-1">
      <div v-if="!routeId" class="form-row doc-serch-form">
        <div class="form-group">
          <div class="input-group">
            <input
              :value="search.email"
              @input="updateSearchField('email', this.lowercaseStr($event.target.value))"
              type="email"
              placeholder="Enter Email"
            />
          </div>
        </div>

        <div class="form-group">
          <div class="input-group">
            <input
              :value="search.phone"
              @input="updateSearchField('phone', $event.target.value)"
              type="number"
              placeholder="Enter Phone"
            />
          </div>
        </div>
        <div class="form-group">
          <div class="input-group sbmt-btn">
            <button class="btn btn-primary" @click="$emit('find-doctor')">
              <i class="fa-solid fa-magnifying-glass"></i>
            </button>
          </div>
        </div>
      </div>
      <p v-if="search.error" class="error">
        {{ search.error }}
      </p>
    </div>
  </div>
</template>

<script>
import { lowercaseString } from '@/utils/helpers';

export default {
  name: "DoctorTabsHeader",
  props: {
    routeId: {
      type: String,
      default: "",
    },
    search: {
      type: Object,
      required: true,
    },
  },
  emits: ["find-doctor", "update:search", "tab-change"],
  methods: {
    updateSearchField(field, value) {
      this.$emit("update:search", {
        ...this.search,
        [field]: value,
      });
    },
    lowercaseStr(value) {
      return lowercaseString(value)
    }
  },
};
</script>

<style scoped>
.tbs-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  border-bottom: 1px solid #60606063;
  padding-bottom: 10px;
}

.tbs-header .tb-inr-1 {
  width: 50%;
}

.doc-serch-form {
  display: flex;
  align-items: center;
  gap: 10px;
}

.doc-serch-form input {
  font-size: 20px;
  padding: 10px 15px;
  border-radius: 30px;
  border: 1px solid #606060;
  width: 189px;
}

.doc-serch-form button {
  padding: 8px 20px;
  font-size: 20px;
}

.doc-serch-form .input-group {
  display: block;
}

.doctor-details ul#myTab {
  border-bottom: 0;
}

ul#myTab li button {
  font-size: 24px;
}

.error {
  color: red;
  font-size: 0.85rem;
  margin-bottom: 0px;
  margin-top: 5px;
}

/* Chrome, Safari, Edge, Opera */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
